import { useEffect, useState } from 'react'

import {
  KyrgyzstanSearchApi,
  RealtyCapacityResponse,
} from 'shared/api/kyrgyzstan/search'
import { getApiErrorMessage } from 'shared/lib/errorText'

interface UseRealtyCapacityProps {
  objectId?: string | null
  startDate?: string
  endDate?: string
}

export const useRealtyCapacity = ({
  objectId,
  startDate,
  endDate,
}: UseRealtyCapacityProps) => {
  const [capacity, setCapacity] = useState<RealtyCapacityResponse | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!objectId || !startDate || !endDate) {
      setCapacity(null)
      return
    }

    const fetchCapacity = async () => {
      try {
        setIsLoading(true)
        setError(null)
        const { data } = await KyrgyzstanSearchApi.getRealtyCapacity(objectId, {
          start_date: startDate,
          end_date: endDate,
        })
        setCapacity(data.data)
      } catch (err) {
        const errorMessage = getApiErrorMessage(err)
        setError(errorMessage)
        setCapacity(null)
      } finally {
        setIsLoading(false)
      }
    }

    void fetchCapacity()
  }, [objectId, startDate, endDate])

  return {
    capacity,
    maxGuests: capacity?.max_guests,
    isLoading,
    error,
  }
}
